import api from './axiosConfig';

export const getVersion = async () => {
  const response = await api.get('/ver');
  return response.data;
};
